__turbopack_context__.v({
  "className": "inter_35583532-module__Be2Baq__className",
  "variable": "inter_35583532-module__Be2Baq__variable",
});
